<template>
    <div>
        <el-card class="box-card">
            <el-form :model="customerChange" ref="customerChangeRef" label-width="82px">
                <el-form-item label="强制暂停" class="addAdminForm">
                    <el-radio v-model="customerChange.usestate" label="2">暂停</el-radio>
                    <el-radio v-model="customerChange.usestate" label="1">开启</el-radio>
                </el-form-item>
                <el-form-item label="备注" class="addAdminForm">
                    <el-input v-model="customerChange.beizhu" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="用户状态" class="addAdminForm">
                  <el-input v-model="customerChange.status1" placeholder="" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="设备状态" class="addAdminForm">
                  <el-input v-model="customerChange.status2" placeholder="" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="机构状态" class="addAdminForm">
                  <el-input v-model="customerChange.status3" placeholder="" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item class="mt20">
                    <el-button type="primary" @click="clicksave">保存</el-button>
                    <el-button type="info" @click="backCustomerManagement">返回</el-button>
                </el-form-item>
            </el-form>

            <div class="title mt20">用户暂停记录</div>
            <el-table :data="listlog" border stripe class="mt15">
                <el-table-column prop="Pausetype" label="操作"></el-table-column>
                <el-table-column prop="Beizhu" label="备注"></el-table-column>
                <el-table-column prop="Adminname" label="操作人员"></el-table-column>
                <el-table-column prop="Createtime" label="操作时间"></el-table-column>
            </el-table>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      customerChange: {
        usestate: '0',
        beizhu: '',
        status1: '',
        status2: '',
        status3: ''
      },
      optionsprovince: [],
      optionscity: [],
      optionsarea: [],
      // 选择机构
      select: {
        keywords: ''
      },
      radio: '1',
      listlog: [],
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.customerChange.usestate = '0'
      this.customerChange.beizhu = ''
      this.apigetcustomerpause()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiaddcustomerpause()
    },
    apigetcustomerpause: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerpause, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.customerChange.status1 = response.data.Userstate
            that.customerChange.status2 = response.data.Glassstate
            that.customerChange.status3 = response.data.Jigoustate

            that.listlog = []
            response.data.List.filter((item, i) => {
              that.listlog.push({ Pausetype: item.Pausetype, Beizhu: item.Beizhu, Adminname: item.Adminname, Createtime: item.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddcustomerpause: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        statustype: this.customerChange.usestate,
        beizhu: this.customerChange.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addcustomerpause, Qs.stringify(data))
        .then(function (response) {
          that.apigetcustomerpause()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
